import React from 'react'
import './modalWindowHeader.css'

import FaClose from 'react-icons/lib/fa/close';
import FaChevronDown from 'react-icons/lib/fa/chevron-down';
import FaChevronUp from 'react-icons/lib/fa/chevron-up';

const modalWindowHeader = (props) => {
    const modalWindowState = props.modalWindowState === props.EModalWindowState.MAXIMIZED ?
        props.EModalWindowState.MINIMIZED : props.EModalWindowState.MAXIMIZED

    return (
        <div className="modalWindowHeader">
            <button onClick={() => props.windowStateChangeHandler(modalWindowState)}>
                {modalWindowState === props.EModalWindowState.MAXIMIZED ? <FaChevronUp/> : <FaChevronDown/>}
            </button>
            <div className="noselect" data-contact-id={props.contactId}>{props.contactName}</div>
            <button onClick={() => props.windowCloseHandler()}><FaClose/></button>
        </div>
    );
}

export default modalWindowHeader;


// WEBPACK FOOTER //
// ./src/common/chat/modalWindow/modalWindowHeader/modalWindowHeader.js